var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"rph-payments"},[_c('li',[_c('RPHPaymentItem',{attrs:{"type":"visa"}})],1),_vm._v(" "),_c('li',[_c('RPHPaymentItem',{attrs:{"type":"mastercard"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }